// Generated from assets/icons/logo-initials.svg (TA-11013).
// Ids are derived per instance via useSvgIdPrefix() so two copies on one
// screen cannot collide. Edit this file rather than re-adding the .svg.
import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';

import { useSvgIdPrefix } from '@hooks/useSvgIdPrefix';

import type { SvgProps } from 'react-native-svg';

export const LogoInitials = (props: SvgProps) => {
  const uid = useSvgIdPrefix();
  return (
    <Svg fill='none' viewBox='0 0 80 75' {...props}>
      <G clipPath={`url(#${uid}-a)`}>
        <Path
          fill='#00D9A5'
          d='M35.12 26.276v-10.8H22.11V0H9.106v15.476H0v10.8h35.119M29.005 62.951c-4.294 0-6.896-2.083-6.896-6.76V33.13H9.1V57.62c0 11.445 7.287 16.905 17.56 16.905 4.03 0 7.542-.783 9.753-2.084V60.613c-1.812 1.3-4.805 2.338-7.407 2.338'
        />
        <Path
          fill='black'
          d='M78.699 26.276v-10.8h-13.01V0H52.687v15.476H43.58v10.8h35.119M72.585 62.951c-4.294 0-6.896-2.083-6.896-6.76V33.13h-13.01V57.62c0 11.445 7.287 16.905 17.56 16.905 4.03 0 7.542-.783 9.753-2.084V60.613c-1.812 1.3-4.805 2.338-7.407 2.338'
        />
      </G>
      <Defs>
        <ClipPath id={`${uid}-a`}>
          <Path fill='white' d='M0 0h80v74.533H0z' />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
